import { toast, ToastOptions, ToastContainer } from 'react-toastify';
import React, { useCallback } from 'react';

export interface IToastProps extends ToastOptions {
  type: 'success' | 'error' | 'info' | 'warning' | 'default';
  message: string | JSX.Element;
}

const defaultToastOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const useToast = () => {
  const notify = useCallback((props: IToastProps) => {
    // Destructure all possible options for clarity and default handling
    const {
      type,
      message,
      autoClose = defaultToastOptions.autoClose,
      position,
      hideProgressBar,
      closeOnClick,
      pauseOnHover,
      draggable,
      progress,
      toastId,
      onClose,
      onOpen,
      className,
      bodyClassName,
      progressClassName,
      ...additionalOptions
    } = props;

    const options: ToastOptions = {
      position,
      autoClose,
      hideProgressBar,
      closeOnClick,
      pauseOnHover,
      draggable,
      progress,
      toastId,
      onClose,
      onOpen,
      className,
      bodyClassName,
      progressClassName,
      ...additionalOptions,
    };

    switch (type) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.error(message, options);
        break;
      case 'info':
        toast.info(message, options);
        break;
      case 'warning':
        toast.warn(message, options);
        break;
      default:
        toast(message, options);
    }
  }, []);

  return { notify };
};
